import { explorerTx, useTx } from '../data/tx';
import { IconAlertCircle, IconCheckCircle, IconExternal, IconSpinner, IconX } from './Icons';

export function Toasts() {
  const { toasts, dismiss } = useTx();
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((x) => (
        <div key={x.id} className="toast" data-kind={x.kind}>
          <span className="toast__icon">{x.kind === 'pending' ? <IconSpinner size={18} /> : x.kind === 'success' ? <IconCheckCircle size={18} /> : <IconAlertCircle size={18} />}</span>
          <div className="toast__text">
            <strong>{x.title}</strong>
            {x.body && <span>{x.body}</span>}
            {x.hash && <a href={explorerTx(x.hash)} target="_blank" rel="noopener noreferrer">Review tx details <IconExternal size={12} /></a>}
          </div>
          <button type="button" className="icon-btn" onClick={() => dismiss(x.id)} aria-label="Dismiss"><IconX size={14} /></button>
        </div>
      ))}
    </div>
  );
}
